import { videosActions } from "./videosSlice";
import {userRequestsActions} from "./userRequestsSlice";


export const ActionCreators = {
	...videosActions,
	...userRequestsActions,
};
